import { SansText } from '../SansText/SansText'
import type { PairWithProps } from './PairWidth.types'

export const PairWith = ({
  className = '',
  title,
  paragraph,
}: PairWithProps): JSX.Element => {
  return (
    <div className={className}>
      <SansText uppercase as="span" fontWeight="500">
        {title}
      </SansText>
      <SansText
        margin="0.4rem 0 0 0"
        dangerouslySetInnerHTML={{
          __html: paragraph,
        }}
      />
    </div>
  )
}
